import { AppContext } from "@components/features/appContext/AppContext";
import Layout from "@components/primitives/layout/Layout";
import { createTitle } from "@utils/config";
import { translation } from "@utils/translation";
import { useContext } from "react";
import { Helmet } from "react-helmet-async";
import Gallery from "./components/Gallery";

function PhotosPage() {
  const { language } = useContext(AppContext);

  return (
    <Layout>
      <Helmet>
        <title>{createTitle(translation(language).header.photos)}</title>
      </Helmet>
      <div className="h-max bg-primary w-full pt-32 pb-20 px-5">
        <h1 className="md:text-3xl text-2xl mb-2">
          {translation(language).photos.title}
        </h1>
        <p className="text-secondary">
          {translation(language).photos.description}
        </p>
        <Gallery />
      </div>
    </Layout>
  );
}

export default PhotosPage;
